import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a group should contains a specific child but does not.
 *
 * @param {accountGroup} spec.group - Id of the group missing a child
 * @param {string} spec.missingChildId - Id of the missing child
 */
export default class MustContainsValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._component = this._chartOfAccounts.findById(spec.group);

		this._missingChild = this._chartOfAccounts.findById(
			spec.missingChildId,
		);
	}

	getComponent() {
		return this._component;
	}

	getMissingChildId() {
		return this._missingChildId;
	}

	getMessage() {
		return _(
			'The group "{name}" must contain all groups flagged with "{child}".',
			{
				name: (this._component && this._component.getName()) || "null",
				child: this._missingChild.getName(),
			},
		);
	}

	static getType() {
		return "MustContainsValidationResult";
	}
}
